// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3olUv","rootSmall":"AddTileButton_rootSmall__3UJu0"};